import { AssetsSearchContract } from '@terra/shared-contracts-assets';
import { createTerraOrpcClient } from '@terra/shared-utils';

const SERVICE_NAME = 'orchestrator';

export const assetsSearchClient = createTerraOrpcClient({
  contract: AssetsSearchContract,
  serviceName: SERVICE_NAME,
});
